$(document).ready(function(){

  $("input").change(function(){

    var totalpot,pot,cbet,pot_odds_pct,pot_odds,pot_odds_pct_str,pot_odds_str;

    if ($.isNumeric($("#potsize").val())){
      pot = parseFloat($("#potsize").val());
      $("#potsize").text(pot);
    }
    else {
      $("#potsize").text("");
    };

    if ($.isNumeric($("#bluff_size").val())){
      cbet = parseFloat($("#bluff_size").val());
      $("#bluff_size").text(cbet);
    }
    else {
      $("#bluff_size").text("");
    };

    totalpot = pot + cbet;
    pot_odds_pct = calcBluffRatioPCT(cbet, totalpot);
    pot_odds = calcPotOdds(cbet, totalpot);
    pot_odds_pct_str = pot_odds_pct.toFixed(2);

    pot_odds_str = pot_odds.toFixed(1);


    $(".span_potsize").text(pot);
    $(".bluff_size").text(cbet);
    $(".totalpot").text(totalpot);

    $("#must_succeed").val(pot_odds_pct_str + "%");
    $(".span_potodds").text(pot_odds_pct_str + '%');
    $(".span_potoddsnum").text(pot_odds_str + ':1');

  });


  function calcBluffRatioPCT(cbet, total){
    var odds = cbet/total;
    return odds*100;
  };

  function calcPotOdds(cbet, total){
    return total/cbet;
  };

});
